export class Provider {
    /**
     * constructor of class
     * please use factory instead
     * @see {this.factory)
     * @param id
     * @param name
     * @param contact
     */
    constructor(id, name, contact) {
        this._id = id;
        this._name = name;
        this._contact = contact;
    }
    /**
     * Factory method to create an instance of this class without
     * having to correctly fill the constructor.
     * !!! You should always use this instead of the constructor !!!
     * @param values
     * @returns {Provider}
     */
    static factory(values) {
        const sanitizedValues = {};
        sanitizedValues.id = values.id || '';
        sanitizedValues.name = values.name || '';
        sanitizedValues.contact = values.contact || [];
        return new Provider(sanitizedValues.id, sanitizedValues.name, sanitizedValues.contact);
    }
    /**
     * gets the internal _id
     * @returns {string}
     */
    get id() {
        return this._id;
    }
    /**
     * sets the internal _id
     * @param value
     */
    set id(value) {
        this._id = value;
    }
    /**
     * gets the name
     * @returns {string}
     */
    get name() {
        return this._name;
    }
    /**
     * sets the name
     * @param {string} value
     */
    set name(value) {
        this._name = value;
    }
    /**
     * gets the contact infos
     */
    get contact() {
        return this._contact;
    }
    /**
     * sets the contact infos
     * @param {string[]} value
     */
    set contact(value) {
        this._contact = value;
    }
}
//# sourceMappingURL=provider.js.map